module.exports = __webpack_public_path__ + "static/work20-8b600219efb280849e8d74ff1b4a2e71.jpg";